import React from "react";
import { useParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import "../../../styles/DocumentDetails.css";
import TopBar from "../../../components/TopBar";
import CustomerDetailsPageActionButtons from "../components/CustomerDetailsPageActionButtons";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import CustomerForm from "../components/CustomerForm";
import { useGetCustomerHandler } from "../dataHandlers/getCustomerHandler";
import DocumentSkeletonForm from "../../../components/DocumentSkeletonForm";

export default function CustomerDetailsPage() {
  useDocumentTitle("Customer Details");
  const { profile_id } = useParams();
  const { customer, isLoading } = useGetCustomerHandler(profile_id);

  if (isLoading || !customer) return <DocumentSkeletonForm />;

  return (
    <Stack direction="column" sx={{ mt: "-1rem" }}>
      {customer && (
        <Box sx={{ pb: 4 }}>
          <TopBar
            title={"Customer Details"}
            subTitle={customer?.profile_id}
            identifier={customer?.profile_id}
          >
            <CustomerDetailsPageActionButtons />
          </TopBar>
        </Box>
      )}

      <CustomerForm
        onSubmit={() => {}}
        apiErrors={{}}
        initialData={customer}
        customerType={customer.type}
        readOnly={true}
        onCancel={() => {}}
      />
    </Stack>
  );
}
